import { post } from '../../utilities/http'
import Notify from '../../utilities/Notify'
import { Popup } from '../../utilities/popup'
import { Progress } from '../../utilities/progress'
import { ActionData, PropsActiveDeactive } from './types'
import Deactive from './Deactive'
import Active from './Active'
import Context from './context'
import { Exception } from '../../utilities/http/type'

function expectError(error: Exception) {
    if (error.type === 'dependency' || error.type === 'development') {
        const errors = Object.values(error.errors)
        const message =
            errors.length > 0
                ? errors[0].description
                : 'Ni idea del porque el error xD'
        Popup.error('Lo sentimos', message)
    } else {
        Popup.ohno(
            'Estamos trabajando para resolver el problema. Por favor intenta nuevamente realizar la operación.'
        )
    }
}

export default function ActivateDeactivate({
    control,
    className = '',
    isEnabled,
    children,
    body,
    type = 'option',
    disabled = false,
    iconHide = false
}: PropsActiveDeactive) {
    async function onClick(data: ActionData) {
        const result = await Popup.open({
            title: data.title,
            children: data.message,
            accept: data.accept,
            icon: isEnabled ? 'lock-close' : 'lock-open',
            color: isEnabled ? 'error' : 'success'
        })
        if (result) {
            Progress.open(isEnabled ? 'Desactivando' : 'Activando')
            const response = await post<any>(data.path, body)
            if (response.data) {
                await control.done()
                Notify.success(data.notify)
                Progress.close()
                control.renderMain()
            } else {
                Progress.close()
                expectError(response.error)
            }
        }
    }

    return (
        <Context.Provider
            value={{ className, isEnabled, onClick, type, disabled, iconHide }}
        >
            {children}
        </Context.Provider>
    )
}

export { Deactive, Active }
